import React, { Component } from 'react';
import PropTypes from 'prop-types';

class Overlay extends Component {
  constructor(props) {
    super(props);

    this.state = {
      active: true,
      closing: false,
    };
  }

  hideOverlay = () => {
    this.setState({
      closing: true,
    });
  };

  closeOverlay = () => {
    this.setState({
      closing: false,
      active: false,
    });

    this.props.onClose();
  };

  render() {
    const { active, closing } = this.state;

    return (
      active && (
        <section className={'overlay' + (closing ? ' closing' : '')} onAnimationEnd={() => (closing ? this.closeOverlay() : null)}>
          <p>
            Esta Tab usa cookies, que permitem facilitar a tua navegação e criar uma experiência otimizada à nossa realidade, registando
            ainda dados referentes à tua participação.
          </p>
          <p className="overlay__label">Li e aceito a Política de Privacidade do MEO</p>
          <button onClick={this.hideOverlay} className="overlay__button">
            Aceito
          </button>
          <a
            href="https://www.telecom.pt/pt-pt/Paginas/politica-privacidade.aspx"
            className="overlay__button"
            target="_blank"
            rel="noopener noreferrer"
          >
            Saber mais
          </a>
        </section>
      )
    );
  }
}

Overlay.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default Overlay;
